export const messageFromError = (error: any) => {
    if (typeof error === 'string') {
        return error;
    }

    if (Array.isArray(error)) {
        return messageFromError(error[0]);
    }

    if (typeof error === 'object') {
        return messageFromObject(error);
    }

    return 'Unparsable error.';
};

function messageFromObject(error: any) {
    if (error.hasOwnProperty('message')) {
        return error.message;
    }

    return 'Unparsable error.';
}
